(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();
(function (App, Service, Handler, Controller, Config, Model, Helper, Analytics, gapi, FB, smartlock, CustomDimension, $) {
    'use strict';

    // ==================================================
    // Llamada ajax generica
    // Params : {url} {data} {success} {error}
    // ==================================================
    Service.ajaxPost = function (url, data, done, error, options) {
        var sentHeader = ((!Helper.isEmpty(options) && 'sentHeader' in options) ? true : false);
        var showPreloader = ((!Helper.isEmpty(options) && 'showPreloader' in options) ? true : false);
        var hidePreloader = ((!Helper.isEmpty(options) && 'hidePreloader' in options) ? true : false);
        var api = ((!Helper.isEmpty(options) && 'paywallApi' in options) ? Config.apiPaywallUrl : Config.apiLoginUrl);
        var headers = {
            'X-Token': Model.Usuario.xToken || '',
            'X-Value': Model.Usuario.xValue || '',
            'X-Key': Model.Usuario.xKey || ''
        };
        showPreloader && Helper.showPreloader();
        $.ajax({
            url: api + url,
            type: 'POST',
            crossDomain: true,
            data: data || null,
            headers: (sentHeader == true ? headers : null),
            success: function (response, status, xhr) {
                //success && success(response,status,xhr);
            },
            error: function (response) {
                error && error(response);
            },
            complete: function (response, status, xhr) {
                if (Config.env === "develop") console.log("Load", url);
            }
        }).done(function (res, status, xhr) {
            try {
                Helper.setCanSubmit(true);
                var r = res;
                if (typeof res == 'string') r = JSON.parse(res);
                done && done(r, status, xhr);
            } catch (e) {
                console.log(e);

                Handler.OnFaildefaultErrorMessage();
            }
        }).fail(function (jqXHR, textStatus, errorThrown) {
            try {
                Handler.failHandler(jqXHR.status);
            } catch (e) {
                console.log(e);

                Handler.OnFaildefaultErrorMessage();
            }
        });
    }
    // ==================================================
    // Inicializacion de la API de Gmail
    // ==================================================   
    Service.startGmailApi = function () {

        gapi && gapi.load('client:auth2', function () {
            var auth2 = gapi.auth2.init({
                client_id: Config.gmId
            });
        });

    }

    Service.onGmailLogin = function (cb) {
        gapi && gapi.auth2.getAuthInstance().isSignedIn.listen(cb);
    }

    // ==================================================
    // Inicializacion de la API de Apple (la config de WEB por default)
    // ==================================================   

    Service.startAppleApi = function (config = Config.SIWA.init) {
        AppleID && AppleID.auth.init(config);
    }


    // ==================================================
    // Inicializacion de la API de Facebook
    // ==================================================   
    Service.startFacebookApi = function () {
        FB && FB.init({
            appId: Config.fbId,
            version: 'v5.0',
            status: true,
            cookie: true,
            xfbml: true
        });
    }

    Service.getFbMe = (cb) => {
        window.FB && window.FB.api('/me?fields=name,email,age_range,currency,first_name,last_name,gender,locale,birthday,hometown,location', (response) => {
            cb && cb(response);
            //Controller.accederFacebookProcesar(response);
        });
    }

    Service.startHotjar = function () {
        (function (h, o, t, j, a, r) {
            h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
            h._hjSettings = { hjid: parseInt(Config.hotjarId), hjsv: 6 };
            a = o.getElementsByTagName('head')[0];
            r = o.createElement('script'); r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    }

    Service.createCustomDimension = function () {

        if (!CustomDimension.exist()) {
            CustomDimension.setRegistrado('no');
            CustomDimension.setSuscriptorType('N/A');
            CustomDimension.setUserId('');
            CustomDimension.save();
        }


        var CD = CustomDimension.get();
        var withToken = Helper.isEmpty(Helper.readCookie('token'));
        var usuarioLogeado = withToken ? 'no' : 'yes';
        var payUser = Helper.isEmpty(Helper.readCookie('ProductoPremiumId')) ? 'no' : 'yes';
        var userId = Helper.readCookie('usuario%5Fid');
        var clubLN = Helper.readCookie('usuarioDetalleClubNacion');
        var notasLeidas = Helper.readCookie('countNotas');

        if (!window.dataLayer) {
            window.dataLayer = [{}];
        }

        dataLayer[0].notasLeidas = notasLeidas ? notasLeidas : 0;
        dataLayer[0].usuarioLogeado = usuarioLogeado;
        dataLayer[0].usuarioRegistrado = CD.usuarioRegistrado;
        dataLayer[0].payUser = payUser;
        dataLayer[0].suscriptorType = CD.suscriptorType;
        dataLayer[0].userId = CD.userId;
        dataLayer[0].credentialType = clubLN ? clubLN : 'N/A';


    }

    Service.startGoogleAnalytics = function () {
        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments)
            }, i[r].l = 1 * new Date(); a = s.createElement(o),
                m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
        ga && ga('create', Config.gaId, 'auto');
    }

    Service.initializeGoogleAnalytics = function () {
        if (typeof ga === 'function' && ga.loaded) {
            return;
        }

        (function init() {
            if (typeof ga === 'function') {
                ga('create', Config.gaId, 'auto');
            }
            else {
                setTimeout(init, 100);
            }
        })();
    };

    Service.startGoogleTagManager = function () {
        (function (w, d, s, l, i) {
            w[l] = w[l] || []; w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            }); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&amp;l=' + l : ''; j.async = true; j.src =
                    '//www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', Config.gtmId);
    }

    Service.startComscore = function () {
        var _comscore = _comscore || [];
        _comscore.push({ c1: "2", c2: "6906398" });
        (function () {
            var s = document.createElement("script"), el = document.getElementsByTagName("script")[0]; s.async = true;
            s.src = (document.location.protocol == "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";
            el.parentNode.insertBefore(s, el);
        })();
    }

    Service.startEstadisticas = function () {
        var rand_no = Math.random();
        var ip = '190.220.56.0'; /* NO SOY FELIZ HACIENDO ESTO -- ALE */
        rand_no = Math.ceil(rand_no * 1000000000);
        $("body").append('<img src="https://estadisticas.lanacion.com.ar/diario/default.gif?pagina=' + Model.Window.location + '&amp;servidor=' + ip + '&amp;nro=' + rand_no + '" width="1" height="1" />');
    }

    Service.mostrarError = function (message, analyticsError, error) {
        Analytics.error(analyticsError || message);
        Helper.callView('MOSTRAR_ERROR', {
            message: message,
            error: error
        });
    }

    Service.mostrarErrorTrackeaForm = function (message, analyticsError, error) {
        Analytics.formError(Helper.getCurrentStep() + '-' + analyticsError);
        Helper.callView('MOSTRAR_ERROR', {
            message: message,
            error: error
        });
    }

    Service.isLogged = function () {
        Model.Usuario.xToken = Helper.readCookie("token");
        var usuario_detalle_guid = Helper.readCookie("usuario%5Fdetalle%5Fguid");
        var cookieLogin = Helper.readCookie("cookieLogin");
        if (Helper.isEmpty(usuario_detalle_guid) || Helper.isEmpty(cookieLogin) || Helper.isEmpty(Model.Usuario.xToken) || Helper.Validators.temporary.test(Model.Usuario.xToken)) return false;
        Service.ajaxPost('/Usuario/Me', false, function (res, status, xhr) {
            if (!Helper.isEmpty(res.code) && res.code === '0000') {

                Helper.returnBack({
                    url: Model.Window.pagina
                });
            }
        }, null, {
                sentHeader: true
            });
    }

    Service.isLoggedONLY = function () {
        Model.Usuario.xToken = Helper.readCookie("token");
        var usuario_detalle_guid = Helper.readCookie("usuario%5Fdetalle%5Fguid");
        var cookieLogin = Helper.readCookie("cookieLogin");
        if (Helper.isEmpty(usuario_detalle_guid) || Helper.isEmpty(cookieLogin) || Helper.isEmpty(Model.Usuario.xToken) || Helper.Validators.temporary.test(Model.Usuario.xToken)) return false;
        return true;
    }

    Service.ifLoggedNextStep = function () {
        if (Service.isLoggedONLY()) {
            var step = $('.next-step').data('step');
            if (step)
                Handler.stepHandler(step);
        }
    }

    Service.ifLoggedReturnBack = function () {
        setInterval(function () {
            Service.isLogged()
        }, Config.returnBackInterval);
    }

    Service.getFacebookInfo = () => {
        window.FB && window.FB.getLoginStatus((response) => {
            if (response.status == 'connected') {
                window.FB.api(
                    '/' + response.authResponse.userID,
                    'GET', {
                        "fields": "first_name,last_name"
                    },
                    function (response) {
                        if (!Helper.isEmpty(response.first_name)) {
                            var mensaje = '&iquest;No sos ' + response.first_name + ' ' + response.last_name + '?';
                            $('.boton-fb a').html(mensaje);
                            $(".boton-fb a").fadeIn("slow");
                        } else {
                            $(".boton-fb a").fadeOut("slow");
                        }
                    }
                );
            } else {
                $(".boton-fb a").fadeOut("slow");
            }
        });
    }

    Service.getGmailInfo = function () {
        gapi && gapi.client.load('plus', 'v1', function () {
            var request = gapi.client.plus.people.get({ 'userId': 'me' });
            request.execute(function (profile) {
                if (!Helper.isEmpty(profile.displayName)) {
                    var mensaje = '&iquest;No sos ' + profile.displayName + '?';
                    $(".boton-gm a").html(mensaje);
                    $(".boton-gm a").fadeIn("slow");
                }
            });
        });
    }

    Service.logoutFacebook = function () {
        var url = window.location.href;
        window.FB && window.FB.logout((response) => {
            $(".boton-fb a").fadeOut("slow");
            window.location.href = url;
        });
    }

    Service.logoutGmail = function () {
        var gaInstance = gapi.auth2.getAuthInstance();

        if (gaInstance.isSignedIn.get()) {
            gaInstance.disconnect().then(function () {
                $(".boton-gm a").fadeOut("slow");
            });
        }
    }

    // ==================================================
    // Setup App
    // ==================================================   
    Service.setup = function () {

    }

    // =================================================
    // Smart Lock
    // =================================================
    Service.autoLogin = function () {
        if (Config.smartLockEnabled) {
            smartlock && smartlock.get(function (r) {
                var cred = r.credential;
                if (cred) {

                    var logTest = /Contrase�a|Email/;
                    if (logTest.test(cred.id)) { // El nombre de la credencial se un dato incorrecto, logea en elmah
                        logger && logger.error('Smartlock | nombre credencial incorrecta', cred);
                    }

                    switch (r.type) {
                        case 'nativo':
                            Controller.accerNativoAutomatico(cred.id, cred.password);
                            console.log('acceso automatico nativo: ' + cred.name);
                            break;
                        case 'fb':
                            Controller.accederFacebookAutomatico(cred.id);
                            console.log('acceso automatico Facebook: ' + cred.name);
                            break;
                        case 'gm':
                            Controller.accederGmailAutomatico(cred.id);
                            console.log('acceso automatico Google: ' + cred.name);
                            break;
                    }

                }
            }, Config.smartlockPasswordEnable);
        }
    }
    Service.storeFB = function (profile) {
        if (!Config.smartLockEnabled) return;
        if (!profile) return;
        var email = profile.email;
        var name = profile.name;
        var iconUrl = 'https://graph.facebook.com/' + profile.id + '/picture?type=small';
        smartlock && smartlock.saveFacebook(email, name, iconUrl);
    }
    Service.storeGM = function (profile) {
        if (!Config.smartLockEnabled) return;
        if (!profile) return;
        var email = profile.getEmail();
        var name = profile.getName();
        var iconUrl = profile.getImageUrl();
        smartlock && smartlock.saveGmail(email, name, iconUrl);
    }
    Service.storeNativo = function (usuario) {
        if (!Config.smartLockEnabled) return;
        if (!Config.smartlockPasswordEnable) return;
        var email = usuario.Email;
        var password = usuario.Clave;
        var name = usuario.UsuarioDetalleNombre + ' ' + usuario.UsuarioDetalleApellido;
        var iconUrl = Config.urlImages + '/avatar/avatar-' + usuario.Avatar + '.jpg';
        smartlock && smartlock.savePassword(email, password, name, iconUrl);
    }

    Service.smartlockSignOut = function () {
        smartlock && smartlock.signOut();
    }

    Service.displayCookiesDeshabilitadasView = function () {
        Handler.setOrigin();
        Helper.addBackground(function () {
            Helper.addHeader();
            Helper.callView('COOKIES_DESHABILITADAS', null, function () {
                $('#btnReloadPage').click(function () {
                    location.reload();
                })
            });
            Helper.resizeHandler();
        });
    };

})(LN.App, LN.Service, LN.Handler, LN.Controller, LN.Config, LN.Model, LN.Helper, LN.Analytics, window.gapi, window.FB, window.smartlock, LN.CustomDimension, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/login/core/service.js